class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

//NOTIFICATION POPUP: ADD ITEM START
this.notification.addEventListener('click', (evt) => {
      const button = evt.target.closest('.popup-quantity-btn');
      if (!button) return;

      if (this.autoCloseTimer) clearTimeout(this.autoCloseTimer);

      const line = button.dataset.index;
      const isPlus = button.getAttribute('name') === 'plus';
      const qtySpan = button.parentElement.querySelector('.cart-quantity-value');

      if (!qtySpan) return;

      const currentQty = parseInt(qtySpan.textContent);
const container = button.closest('.cart-item__quantity-selector');
const max = parseInt(container.dataset.max) || 999;

const newQty = isPlus ? currentQty + 1 : currentQty - 1;

if (newQty < 0) return;
if (newQty > max) return;

const addToCartBtn = document.querySelector('.product-form__submit');
const spinner = addToCartBtn?.querySelector('.loading__spinner');

if (addToCartBtn && spinner) {
  addToCartBtn.classList.add('loading');
  addToCartBtn.setAttribute('aria-disabled', true);
  spinner.classList.remove('hidden');
}

fetch(`${routes.cart_change_url}.js`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  body: JSON.stringify({
    line: line,
    quantity: newQty
  })
})
.then(response => response.json())
.then(cart => {
  qtySpan.textContent = newQty;

  const updatedItem = cart.items[line - 1];
  const priceElement = button.closest('.cart-item')
    ?.querySelector('.notification_item_price');

  if (priceElement && updatedItem) {
    priceElement.textContent = Shopify.formatMoney(
      updatedItem.final_line_price,
      window.shopMoneyFormat
    );
  }
  
  const bubble = document.getElementById('cart-icon-bubble');
 if (bubble) {
  const visibleCount = bubble.querySelector('[aria-hidden="true"]');
  const srText = bubble.querySelector('.visually-hidden');

  if (visibleCount) {
    visibleCount.textContent = cart.item_count;
  }

  if (srText) {
    srText.textContent = `${cart.item_count} items`;
  }
}
  if (newQty === 0) {
    const itemElement = button.closest('.cart-item');
    if (itemElement) itemElement.remove();
  }

  this.updatePopupQuantityButtons();

})
.catch(error => {
  console.error('Cart update failed:', error);
})
.finally(() => {
  const updatedSubmitButton = document.querySelector('product-form [type="submit"]');
  const spinner = updatedSubmitButton?.querySelector('.loading__spinner');

  if (updatedSubmitButton) {
    updatedSubmitButton.classList.remove('loading');
    updatedSubmitButton.removeAttribute('aria-disabled');
  }

  if (spinner) {
    spinner.classList.add('hidden');
  }
});
    });
//NOTIFICATION POPUP: ADD ITEM END
    
  }

  // open() {
  //   this.notification.classList.add('animate', 'active');

  //   this.notification.addEventListener(
  //     'transitionend',
  //     () => {
  //       this.notification.focus();
  //       trapFocus(this.notification);
  //     },
  //     { once: true }
  //   );

  //   document.body.addEventListener('click', this.onBodyClick);
  // }
  open() {
  this.notification.classList.add('animate', 'active');

  this.autoCloseTimer = setTimeout(() => {
  if (!this.notification.matches(':hover')) {
    this.notification.classList.remove('active');
  }
}, 3000);

  this.notification.addEventListener(
    'transitionend',
    () => {
      this.notification.focus();
      trapFocus(this.notification);
    },
    { once: true }
  );

  document.body.addEventListener('click', this.onBodyClick);
}


  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

renderContents(parsedState) {    
  this.cartItemKey = parsedState.key;

  this.getSectionsToRender().forEach((section) => {
    const element = document.getElementById(section.id);

    if (element && parsedState.sections[section.id]) {
      element.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    }
  });

  if (this.header) this.header.reveal();
  //function call of notification pop add items
  this.updatePopupQuantityButtons();
  this.open();
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },      
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-heading-count',
      },
      {
        id: 'cart-count-mobile',
      }
    ];
  }

// getSectionInnerHTML(html, selector = '.shopify-section') {
//   const doc = new DOMParser().parseFromString(html, 'text/html');
//   const selected = doc.querySelector(selector);
//   return selected ? selected.innerHTML : ''; // fallback if missing
// }

  // getSectionInnerHTML(html, selector = '.shopify-section') {
  //   return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  // }

    getSectionInnerHTML(html, selector = '.shopify-section') {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const selected = doc.querySelector(selector);
  return selected ? selected.innerHTML : '';
}

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // FUNTION FOR NOTIFICATION POPUP ADDITION OF ITEMS
  updatePopupQuantityButtons() {
  this.notification.querySelectorAll('.cart-item__quantity-selector').forEach(container => {

    const max = parseInt(container.dataset.max) || 999;
    const qty = parseInt(container.querySelector('.cart-quantity-value')?.textContent || 0);

    const plusBtn = container.querySelector('[name="plus"]');
    const minusBtn = container.querySelector('[name="minus"]');

    if (plusBtn) plusBtn.disabled = qty >= max;
    if (minusBtn) minusBtn.disabled = qty <= 1;

  });
}
}

customElements.define('cart-notification', CartNotification);